export default __webpack_public_path__ + "static/media/me-360px.985ae042.png";